module.exports = __webpack_public_path__ + "static/media/scratch.9fa074cb.mp3";